import styled from "styled-components";
import PropTypes from "prop-types";
import COLORS from "../utils/colors";

/*
An underlined paragraph element component. 
Takes in a color for both the font and the underline 
then renders the text with it.
*/
const UnderlinedParagraph = styled.span`
  color: ${(props) => props.color};
  border-bottom: ${(props) => props.thickness} solid
    ${(props) => props.underlineColor};
`;

UnderlinedParagraph.propTypes = {
  underlineColor: PropTypes.string.isRequired,
};

UnderlinedParagraph.defaultProps = {
  color: "white",
  underlineColor: COLORS.GREEN,
  thickness: "3px",
};

export default UnderlinedParagraph;
